/* eslint-disable react/prop-types */
import React from 'react';
import { Tooltip } from 'antd';
import { formatTokenCount, formatUsd, normalizeUsage } from '../../services/aiInsightsApi';

/**
 * Per-answer token line (only when API returns real usage):
 * INPUT: 12,544 · OUTPUT: 2,637 · EST. COST: $0.08
 */
const SpacerLogAiUsageLine = ({ usage, inline = false }) => {
  const u = normalizeUsage(usage);
  if (!u) return null;

  return (
    <div
      className={`spacer-ask-evans__usage${inline ? ' spacer-ask-evans__usage--inline' : ''}`}
      role="status"
      aria-label="Token usage for this answer"
    >
      <Tooltip title="Prompt / question side (facts + history + question)">
        <span className="spacer-ask-evans__usage-item">
          INPUT: {formatTokenCount(u.inputTokens)}
        </span>
      </Tooltip>
      <span className="spacer-ask-evans__usage-sep" aria-hidden>
        ·
      </span>
      <Tooltip title="Model reply size">
        <span className="spacer-ask-evans__usage-item">
          OUTPUT: {formatTokenCount(u.outputTokens)}
        </span>
      </Tooltip>
      <span className="spacer-ask-evans__usage-sep" aria-hidden>
        ·
      </span>
      <Tooltip title="Rough cost for this call">
        <span className="spacer-ask-evans__usage-item">
          EST. COST: {formatUsd(u.estimatedCostUsd)}
        </span>
      </Tooltip>
    </div>
  );
};

export default SpacerLogAiUsageLine;
